import HeroSection from "../../Components/HeroSection";
import HowItWorksSection from "../../Components/HowItWorksSection";
import BookSpotForm from "../../Components/BookSpotForm";
import WhatMakesShyftBootCampUniqueSection from "../../Components/WhatMakesShyftBootCampUniqueSection";
import CallbackSection from "../../Components/CallbackSection";
import Testimonials from "@/components/Organisms/TestimonialsV2";
import RealWorldTransformation from "../../Components/RealWorldTransformation";
import AppBannerSection from "../../Components/AppBannerSection";
import CallbackStrip from "../../Components/CallbackStrip";
import BootcampListing from "../../Components/BootcampListing";
import AllPackagesSection from "../../Components/AllPackagesSection";
import ReadyToBuildSection from "../../Components/ReadyToBuildSection";
import FaqSection from "@/components/Molecules/FaqSection";
import FloatingBanner from "../../Components/FloatingBanner";
import BookSlotModal from "../../Components/BookSlotModal";
import CustomIntercomButton from "../../Components/CustomIntercomButton";

import CertifiedInstructors from "../../Components/Shared/CertifiedInstructors";

import { classNameGenerator } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./NutritionBootcampPage.module.scss";
import PreConsultationSection from "../../Components/PreConsultationSection";

interface NutritionBootcampPageProps {}

const NutritionBootcampPage: React.FC<NutritionBootcampPageProps> = () => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const { testimonies } = data?.testimonials || {};
  const faqs = data?.faqs || {};

  return (
    <div className={cls("nutritionBootcampPage")}>
      <HeroSection />
      <HowItWorksSection>
        <BookSpotForm />
      </HowItWorksSection>
      <PreConsultationSection />
      <WhatMakesShyftBootCampUniqueSection />
      <Testimonials testimonies={testimonies} />
      <CallbackSection />
      <RealWorldTransformation />
      <AllPackagesSection />
      <AppBannerSection />
      <CallbackStrip />
      <div className={cls("certifiedInstructors")}>
        <CertifiedInstructors />
      </div>
      <BootcampListing />
      <FaqSection {...faqs} />
      <ReadyToBuildSection />
      <FloatingBanner />
      <BookSlotModal title={data?.bookSlotForm?.title} />
      {/* <CustomIntercomButton /> */}
    </div>
  );
};

export default NutritionBootcampPage;
